// extracted by mini-css-extract-plugin
export default {"linkButton":"columns_linkButton__h598i","clickableText":"columns_clickableText__uYtx-"};